import { Injectable, ChangeDetectorRef, NgZone, Sanitizer } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ConnectionService, ConnectionServiceModule } from 'ng-connection-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {TranslateService} from '@ngx-translate/core';
import {Observable, Subject} from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

declare global {
  interface Window {
    RTCPeerConnection: any;
    mozRTCPeerConnection: any;
    webkitRTCPeerConnection: any;
  }
}

declare function checkQuestionPosition(): any;
declare var navigator: any;
declare var Connection: any;
declare function saveMediaUsage(): any;

@Injectable({
  providedIn: 'root'
})

export class DataService {
  public isAssessor = false;
  public dataDownloaded = false;
  public processing = [];
  public disconnectTime = 0;
  public syncProgress = "0%";
  public syncIndex = 0;
  public environment = "https://enetcloud-demo-enetassess-base-api-testing.azurewebsites.net/"; //"https://enetcloud-demo-enetassess-base-api-testing.azurewebsites.net/"; 
  public blobUrl = "";//"https://ecomstorageproduction.blob.core.windows.net";
  public blobContainer = "base-enetassess-staging";//"iwcf-cdn-test";
  public assessBlobContainer = "base-enetassess-staging";
  public aibcMode = true;
  public kioskMode = false;
  public prefixBlobUrl = "";
  public syncItems = [];
  public previewSyncItems = [];
  public assessmentFrontPages: any = [];
  public bops: any = [];
  public caseStudies: any = [];
  public caseStudyInstructions: any = [];
  public caseStudyMedia: any = [];
  public languages: any = [];
  public levels: any = [];
  public media: any = [];
  public modules: any = [];
  public programmes: any = [];
  public questionEnglishTranslations: any = [];
  public questionMatches: any = [];
  public questionMedia: any = [];
  public questionResponseMedia: any = [];
  public questionResponses: any = [];
  public questions: any = [];
  public tasks: any = [];
  public mocks:any = [];
  public scheduleCandidates: any = [];
  public schedules: any = [];
  public sessionFeedbacks: any = [];
  public sessionQuestions: any = [];
  public sessionResults: any = [];
  public sessions: any = [];
  public assessments: any = [];
  public units: any = [];
  public currentUser: any = {};
  public currentExamIndex = -1;
  public downloadStatus = "Loading exam data...";
  public syncStatus = "Up to date...";
  public isConnected = true;
  public timeDisconnected = 0;
  public disconnectInterval;
  public connectionFailInterval;
  public connectionFailCount;
  public expandMenu = false;
  public tinyUrl = "";
  public lastAction = "";
  public ipAddress = "";
  public publicIpAddress = "";
  public pendingApiCalls = [];
  public currentSectionName = "";
  public showSectionWelcome = false;
  public sectionWelcomeCounter = 5;
  public sectionInterval;
  public sectionTimeout;
  public deviceInfo = "";
  private ipRegex = new RegExp(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/);
  public questionSettings = {
    showQuestionText: true
  };

  public changeQuestionTimer: any;
  private subject = new Subject<any>();
  private mediaUsageSubject = new Subject<any>();

  public context: SafeHtml = "";
  public supplementary: SafeHtml = "";
  public questionText: SafeHtml = "";
  public questionName: SafeHtml = "";
  public previewLoaded = false;
  public previewMode = false;
  public intervalUpdateQuestionText;
  public questionLayoutTimer;
  public questionLayoutInterval;
  public assessorName = "";
  public assessorExam = false;
  public anonymousCandidateExam = false;
  public demoExam = false;
  public enetsecureMobile = false;
  public enetsecureWeb = false;
  public exmUrl = "";
  public showTimerAlert = false;
  public showTimerAlertCounter = 5;
  public register = false;
  public registerExamId = 0;

  constructor(
    private http: HttpClient,
    public generalSvc: GeneralService,
    private spinner: NgxSpinnerService,
    private spinner2: Ng4LoadingSpinnerService,
    private connectionService: ConnectionService,
    private deviceService: DeviceDetectorService,
    public translate: TranslateService,
    private zone: NgZone,
    public sanitizer: DomSanitizer
  ) {
    

    try {
      this.deviceInfo = (deviceService.os) + "_" + (deviceService.os_version) + "_" + (deviceService.browser) + "_" + (deviceService.browser_version);
    } catch (e) {

    }

    this.determineLocalIp();
    this.determinePublicIp();
    setTimeout(() => {
      this.refetchConfigSettings();
    },1000);
    

    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        clearInterval(this.disconnectInterval);
        if (this.timeDisconnected > 0)
        {
          var timeOfDisconnect = this.timeDisconnected + 1;
          if (this.currentExamIndex != -1)
          {
            this.startSyncMethods();
            var sessionId = this.currentExam().Session.SessionId;
            this.submitDisconnect(sessionId, (timeOfDisconnect * 1000));
          }
          this.timeDisconnected = 0;
          this.spinner.hide();
        }
      } 
      else {
        this.stopSyncMethods();
        this.downloadStatus = "No internet connection...";
        this.timeDisconnected = 0;
        this.spinner.show();
        this.disconnectInterval = setInterval(() => {
          this.timeDisconnected ++;
          this.downloadStatus = "No internet connection. Disconnected for "+ this.timeDisconnected.toString() +" seconds...";
        }, 1000);
      }
    });
  }

  refetchConfigSettings(){
    const jsonFile = "/assets/config.json";
    this.http.get(jsonFile).toPromise().then((response: any) => {
      this.environment = response.webApiUrl;
      this.blobUrl = response.blobStorageUrl;
      this.blobContainer = response.blobStorageContainer;
      this.aibcMode = response.aibcMode;
      this.register = response.register;
      this.registerExamId = response.registerExamId;
      this.assessBlobContainer = response.assessBlobStorageContainer;
      this.kioskMode = response.kioskMode;
      this.syncItems = response.dataSyncItems;
      this.previewSyncItems = response.previewSyncItems;
      this.exmUrl = response.exmUrl;
    });
  }

  changeLangauge(language){
    localStorage.setItem("userslanguage", language.toString());
    this.translate.setDefaultLang(language.toString());
    this.translate.use(language.toString());
  }
  

  private determineLocalIp() {
    window.RTCPeerConnection = this.getRTCPeerConnection();

    const pc = new RTCPeerConnection({ iceServers: [] });
    pc.createDataChannel('');
    pc.createOffer().then(pc.setLocalDescription.bind(pc));

    pc.onicecandidate = (ice) => {
      this.zone.run(() => {
        if (!ice || !ice.candidate || !ice.candidate.candidate) {
          return;
        }
        try{
          this.ipAddress = this.ipRegex.exec(ice.candidate.candidate)[1];
        }
        catch{
           this.ipAddress = "127.0.0.1";
        }
        
        pc.onicecandidate = () => {};
        pc.close();
      });
    };
  }

  private getRTCPeerConnection() {
    return window.RTCPeerConnection ||
      window.mozRTCPeerConnection ||
      window.webkitRTCPeerConnection;
  }

  private determinePublicIp(){
    this.http.get<{ip:string}>('https://jsonip.com')
    .subscribe( data => {
      this.publicIpAddress = data.ip;
    });
  }


  initLogin(username, password) {
    for (var i = 0; i < localStorage.length; i++){
      if(localStorage.key(i).indexOf("chosenMap") > 0){
        localStorage.removeItem(localStorage.key(i));
      }
    }
    
    this.spinner.show();
    this.downloadStatus = "Logging in...";
    var loginUrl = this.environment + "/authentication/login/" + username + "/" + password;
    this.http.get(loginUrl).subscribe((data: any) => {
          if (data.status == "Success") {
            if(username == "demo" && password == "demo"){
              this.demoExam = true;
            }
            this.downloadStatus = "Downloading exam data...";
            this.prefixBlobUrl = this.blobUrl + "/"+ this.blobContainer +"/"+ data.scheduleId + "-" + data.scheduleCandidateId;// + "-" + password;
            var suffixUrl = this.makeid(10);
            
            this.syncItems[0].url = this.prefixBlobUrl + "/QuestionResponseMedia.json?" + suffixUrl;            
            this.syncItems[1].url = this.prefixBlobUrl + "/QuestionResponses.json?" + suffixUrl;
            this.syncItems[2].url = this.prefixBlobUrl + "/Questions.json?" + suffixUrl;
            this.syncItems[3].url = this.prefixBlobUrl + "/ScheduleCandidates.json?" + suffixUrl;
            this.syncItems[4].url = this.prefixBlobUrl + "/Schedules.json?" + suffixUrl;
            this.syncItems[5].url = this.prefixBlobUrl + "/SessionQuestions.json?" + suffixUrl;            
            this.syncItems[6].url = this.prefixBlobUrl + "/Sessions.json?" + suffixUrl;
            this.syncItems[7].url = this.prefixBlobUrl + "/SessionResults.json?" + suffixUrl;
            this.syncItems[8].url = this.prefixBlobUrl + "/Tasks.json?" + suffixUrl;
            this.syncItems[9].url = this.prefixBlobUrl + "/Mocks.json?" + suffixUrl;
            this.syncItems[10].url = this.prefixBlobUrl + "/Media.json?" + suffixUrl;
            this.syncItems[11].url = this.prefixBlobUrl + "/Assessment.json?" + suffixUrl;

            this.processSync(username, password);
          } else if (data.status == "Error") {
            this.downloadStatus = data.message;
            setTimeout(() => {
              this.spinner.hide();
            }, 5000);
          } else {
            this.downloadStatus = "Login details incorrect";
            setTimeout(() => {
              this.spinner.hide();
            }, 1000);
          }
        }, (error: any) => {
          this.downloadStatus = "Error logging in";
          setTimeout(() => {
            this.spinner.hide();
          }, 1000);
        });
  }

  initAnonymousCandidateLogin(cauth){
    this.refetchConfigSettings();
    setTimeout(() => {
      this.spinner.show();
    this.downloadStatus = "Loading exam data";
    var loginUrl = this.environment + "/authentication/anonymousCandidatelogin/" + cauth;
    console.log(loginUrl);
    this.http.get(loginUrl).subscribe((data: any) => {
      console.log(data);
      if (data.status == "Success") {
        this.downloadStatus = "Downloading exam data...";
        this.prefixBlobUrl = this.blobUrl + "/"+ this.blobContainer +"/"+ data.scheduleId + "-" + data.scheduleCandidateId;// + "-" + password;
        var suffixUrl = this.makeid(10);
        this.anonymousCandidateExam = true;
        this.syncItems[0].url = this.prefixBlobUrl + "/QuestionResponseMedia.json?" + suffixUrl;            
        this.syncItems[1].url = this.prefixBlobUrl + "/QuestionResponses.json?" + suffixUrl;
        this.syncItems[2].url = this.prefixBlobUrl + "/Questions.json?" + suffixUrl;
        this.syncItems[3].url = this.prefixBlobUrl + "/ScheduleCandidates.json?" + suffixUrl;
        this.syncItems[4].url = this.prefixBlobUrl + "/Schedules.json?" + suffixUrl;
        this.syncItems[5].url = this.prefixBlobUrl + "/SessionQuestions.json?" + suffixUrl;            
        this.syncItems[6].url = this.prefixBlobUrl + "/Sessions.json?" + suffixUrl;
        this.syncItems[7].url = this.prefixBlobUrl + "/SessionResults.json?" + suffixUrl;
        this.syncItems[8].url = this.prefixBlobUrl + "/Tasks.json?" + suffixUrl;
        this.syncItems[9].url = this.prefixBlobUrl + "/Mocks.json?" + suffixUrl;
        this.syncItems[10].url = this.prefixBlobUrl + "/Media.json?" + suffixUrl;
          this.syncItems[11].url = this.prefixBlobUrl + "/Assessment.json?" + suffixUrl;

        this.processAnonymousCandidateSync(data.username, data.password);
      } else if (data.status == "Error") {
        this.downloadStatus = data.message;
        setTimeout(() => {
          this.spinner.hide();
        }, 5000);
      } else {
        this.downloadStatus = "Error launching candidate exam";
        setTimeout(() => {
          this.spinner.hide();
        }, 1000);
      }
    }, (error: any) => {
      this.downloadStatus = "Error launching candidate exam";
      setTimeout(() => {
        this.spinner.hide();
      }, 1000);
    });
    },1000);   
  }

  initAssessorLogin(aauth){
    this.isAssessor = true;
    this.refetchConfigSettings();
    setTimeout(() => {
      this.spinner.show();
      this.downloadStatus = "Loading exam data";
      var loginUrl = this.environment + "/authentication/assessorlogin/" + aauth;
      
      this.http.get(loginUrl).subscribe((data: any) => {
        
        if (data.status == "Success") {
          this.assessorName = data.assessorId;
          this.assessorExam = true;
          this.downloadStatus = "Downloading exam data...";
          this.prefixBlobUrl = this.blobUrl + "/"+ this.blobContainer +"/"+ data.scheduleId + "-" + data.scheduleCandidateId;// + "-" + password;
          var suffixUrl = this.makeid(10);
          
          this.syncItems[0].url = this.prefixBlobUrl + "/QuestionResponseMedia.json?" + suffixUrl;            
          this.syncItems[1].url = this.prefixBlobUrl + "/QuestionResponses.json?" + suffixUrl;
          this.syncItems[2].url = this.prefixBlobUrl + "/Questions.json?" + suffixUrl;
          this.syncItems[3].url = this.prefixBlobUrl + "/ScheduleCandidates.json?" + suffixUrl;
          this.syncItems[4].url = this.prefixBlobUrl + "/Schedules.json?" + suffixUrl;
          this.syncItems[5].url = this.prefixBlobUrl + "/SessionQuestions.json?" + suffixUrl;            
          this.syncItems[6].url = this.prefixBlobUrl + "/Sessions.json?" + suffixUrl;
          this.syncItems[7].url = this.prefixBlobUrl + "/SessionResults.json?" + suffixUrl;
          this.syncItems[8].url = this.prefixBlobUrl + "/Tasks.json?" + suffixUrl;
          this.syncItems[9].url = this.prefixBlobUrl + "/Mocks.json?" + suffixUrl;
          this.syncItems[10].url = this.prefixBlobUrl + "/Media.json?" + suffixUrl;
          this.syncItems[11].url = this.prefixBlobUrl + "/Assessment.json?" + suffixUrl;

          this.processAssessorSync(data.username, data.password);
        } else if (data.status == "Error") {
          this.downloadStatus = data.message;
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        } else {
          this.downloadStatus = "Error launching candidate exam";
          setTimeout(() => {
            this.spinner.hide();
          }, 1000);
        }
      }, (error: any) => {
        this.downloadStatus = "Error launching candidate exam";
        setTimeout(() => {
          this.spinner.hide();
        }, 1000);
      });
    },1000);   
  }
  
  submitTrialLogin(fullName: string, email: string) {
    for (var i = 0; i < localStorage.length; i++){
      if(localStorage.key(i).indexOf("chosenMap") > 0){
        localStorage.removeItem(localStorage.key(i));
      }
    }
    
    this.spinner.show();
    this.downloadStatus = "Logging in...";
    var loginUrl = this.environment + "/authentication/triallogin/" + email + "/" + fullName + "/" + this.registerExamId;
    this.http.get(loginUrl).subscribe((data: any) => {
          if (data.status == "Success") {
            this.downloadStatus = "Downloading exam data...";
            this.prefixBlobUrl = this.blobUrl + "/"+ this.blobContainer +"/"+ data.scheduleId + "-" + data.scheduleCandidateId;// + "-" + password;
            var suffixUrl = this.makeid(10);
            
            this.syncItems[0].url = this.prefixBlobUrl + "/QuestionResponseMedia.json?" + suffixUrl;            
            this.syncItems[1].url = this.prefixBlobUrl + "/QuestionResponses.json?" + suffixUrl;
            this.syncItems[2].url = this.prefixBlobUrl + "/Questions.json?" + suffixUrl;
            this.syncItems[3].url = this.prefixBlobUrl + "/ScheduleCandidates.json?" + suffixUrl;
            this.syncItems[4].url = this.prefixBlobUrl + "/Schedules.json?" + suffixUrl;
            this.syncItems[5].url = this.prefixBlobUrl + "/SessionQuestions.json?" + suffixUrl;            
            this.syncItems[6].url = this.prefixBlobUrl + "/Sessions.json?" + suffixUrl;
            this.syncItems[7].url = this.prefixBlobUrl + "/SessionResults.json?" + suffixUrl;
            this.syncItems[8].url = this.prefixBlobUrl + "/Tasks.json?" + suffixUrl;
            this.syncItems[9].url = this.prefixBlobUrl + "/Mocks.json?" + suffixUrl;
            this.syncItems[10].url = this.prefixBlobUrl + "/Media.json?" + suffixUrl;
            this.syncItems[11].url = this.prefixBlobUrl + "/Assessment.json?" + suffixUrl;

            var username = data.username;
            var password = data.password;

            localStorage.setItem("tUsername", username);
            localStorage.setItem("tPassword", password);

            this.processSync(username, password);
          } else if (data.status == "Error") {
            this.downloadStatus = data.message;
            setTimeout(() => {
              this.spinner.hide();
            }, 5000);
          } else {
            this.downloadStatus = "Login details incorrect";
            setTimeout(() => {
              this.spinner.hide();
            }, 1000);
          }
        }, (error: any) => {
          this.downloadStatus = "Error logging in";
          setTimeout(() => {
            this.spinner.hide();
          }, 1000);
        });
  }

  initMockLogin(username, password, mockId, name) {
    for (var i = 0; i < localStorage.length; i++){
      if(localStorage.key(i).indexOf("chosenMap") > 0){
        localStorage.removeItem(localStorage.key(i));
      }
    }
    
    this.spinner.show();
    this.downloadStatus = "Logging in...";
    var loginUrl = this.environment + "/authentication/mocklogin/" + username + "/" + password + "/" + mockId + "/" + name;
    this.http.get(loginUrl).subscribe((data: any) => {
          if (data.status == "Success") {
            this.downloadStatus = "Downloading exam data...";
            this.prefixBlobUrl = this.blobUrl + "/"+ this.blobContainer +"/"+ data.scheduleId + "-" + data.scheduleCandidateId;
            var suffixUrl = this.makeid(10);
            
            this.syncItems[0].url = this.prefixBlobUrl + "/QuestionResponseMedia.json?" + suffixUrl;            
            this.syncItems[1].url = this.prefixBlobUrl + "/QuestionResponses.json?" + suffixUrl;
            this.syncItems[2].url = this.prefixBlobUrl + "/Questions.json?" + suffixUrl;
            this.syncItems[3].url = this.prefixBlobUrl + "/ScheduleCandidates.json?" + suffixUrl;
            this.syncItems[4].url = this.prefixBlobUrl + "/Schedules.json?" + suffixUrl;
            this.syncItems[5].url = this.prefixBlobUrl + "/SessionQuestions.json?" + suffixUrl;            
            this.syncItems[6].url = this.prefixBlobUrl + "/Sessions.json?" + suffixUrl;
            this.syncItems[7].url = this.prefixBlobUrl + "/SessionResults.json?" + suffixUrl;
            this.syncItems[8].url = this.prefixBlobUrl + "/Tasks.json?" + suffixUrl;
            this.syncItems[9].url = this.prefixBlobUrl + "/Mocks.json?" + suffixUrl;
            this.syncItems[10].url = this.prefixBlobUrl + "/Media.json?" + suffixUrl;
            this.syncItems[11].url = this.prefixBlobUrl + "/Assessment.json?" + suffixUrl;

            this.processSync(username, password);
          } else if (data.status == "Error") {
            this.downloadStatus = data.message;
            setTimeout(() => {
              this.spinner.hide();
            }, 5000);
          } else {
            this.downloadStatus = "Login details incorrect";
            setTimeout(() => {
              this.spinner.hide();
            }, 1000);
          }
        }, (error: any) => {
          this.downloadStatus = "Error logging in";
          setTimeout(() => {
            this.spinner.hide();
          }, 1000);
        });
  }

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  processSync(username, password) {
    if (this.dataDownloaded == false) {
      // We check to see if the sync Items contains the index - if not, the progress is completed;
      if (this.syncItems[this.syncIndex] != null) {
        // Get data from JSON;
        // - replace with Web Service;
        this.downloadStatus = "Downloading "+ this.syncItems[this.syncIndex].title +"...";
        this.http.get(this.syncItems[this.syncIndex].url).subscribe((data) => {
          // Bind data;
          this[this.syncItems[this.syncIndex].object] = data;
          this.calculateProgress();

          // Iterate;
          this.syncIndex++;
          this.processSync(username, password);
        },
        (error: any) => {
          //
          console.log(error);
          this.noConnectionError();
        });
      } else {
        this.dataDownloaded = true;
        this.attemptLogin(username, password);
      }
    } else {
      this.attemptLogin(username, password);
    }
  }

  processAssessorSync(username, password) {
    if (this.dataDownloaded == false) {
      // We check to see if the sync Items contains the index - if not, the progress is completed;
      if (this.syncItems[this.syncIndex] != null) {
        // Get data from JSON;
        // - replace with Web Service;
        this.downloadStatus = "Downloading "+ this.syncItems[this.syncIndex].title +"...";
        this.http.get(this.syncItems[this.syncIndex].url).subscribe((data) => {
          // Bind data;
          this[this.syncItems[this.syncIndex].object] = data;
          this.calculateProgress();

          // Iterate;
          this.syncIndex++;
          this.processAssessorSync(username, password);
        },
        (error: any) => {
          //
          console.log(error);
          this.noConnectionError();
        });
      } else {
        this.dataDownloaded = true;
        this.attemptAssessorLogin();
      }
    } else {
      this.attemptLogin(username, password);
    }
  }

  processAnonymousCandidateSync(username, password) {
    if (this.dataDownloaded == false) {
      // We check to see if the sync Items contains the index - if not, the progress is completed;
      if (this.syncItems[this.syncIndex] != null) {
        // Get data from JSON;
        // - replace with Web Service;
        this.downloadStatus = "Downloading "+ this.syncItems[this.syncIndex].title +"...";
        this.http.get(this.syncItems[this.syncIndex].url).subscribe((data) => {
          // Bind data;
          this[this.syncItems[this.syncIndex].object] = data;
          this.calculateProgress();

          // Iterate;
          this.syncIndex++;
          this.processAnonymousCandidateSync(username, password);
        },
        (error: any) => {
          //
          console.log(error);
          this.noConnectionError();
        });
      } else {
        this.dataDownloaded = true;
        this.attemptAssessorLogin();
      }
    } else {
      this.attemptLogin(username, password);
    }
  }

  processPreviewSync() {
    if (this.dataDownloaded == false) {
      // We check to see if the sync Items contains the index - if not, the progress is completed;
      if (this.previewSyncItems[this.syncIndex] != null) {
        // Get data from JSON;
        // - replace with Web Service;
        this.downloadStatus = "Downloading "+ this.previewSyncItems[this.syncIndex].title +"...";
        this.http.get(this.previewSyncItems[this.syncIndex].url).subscribe((data) => {
          // Bind data;
          this[this.previewSyncItems[this.syncIndex].object] = data;
          //this.calculateProgress();

          // Iterate;
          this.syncIndex++;
          this.processPreviewSync();
        },
        (error: any) => {
          //
          console.log(error);
          this.noConnectionError();
        });
      } else {
        this.dataDownloaded = true;
        this.attemptPreview();
      }
    } else {
      this.attemptPreview();
    }
  }

  attemptPreview(){
    var exams = [];    
    var questions = [];
    var question = this.questions[0];

    var questionResponses = this.questionResponses.filter(x => x.QuestionId == question.Question.QuestionID);
    var _questionResponses = [];
    var questionResults = {
      "Selection": "",
      "MediaViewCount": 0,
      "_MediaViewCount": 0,
      "Timetaken": 0,
    };

    questionResponses.forEach(questionResponse => {     
      //var questionResponseMedia = this.questionResponseMedia.filter(x => x.AnswerId == questionResponse.AnswerId);
      _questionResponses.push({
        "Response": questionResponse,
        //"Media": questionResponseMedia,
      })
    });

    questions.push({
      "Question": question,
      "QuestionResponses": _questionResponses,
      "Result": questionResults
    });
      
    exams.push({
      "Questions": questions,
      "CurrentQuestion": 0,              
    });
    this.currentExamIndex = 0;
    exams.forEach(exam => {
      exam.Questions.forEach(question => {
        question.Question.QuestionTextHiddenImages = this.processQuestionContent(question.Question.Question.Text, question.Question, false);
        question.Question.QuestionText = this.processQuestionContent(question.Question.Question.Text, question.Question, true);
      });
    });
    
    exams = JSON.parse(JSON.stringify(exams));

    this.currentUser = {
      "Exams": exams,
      "Language": {
        "Name" : "English"
      }
    };
    
    this.setUpQuestionInfo();

    this.previewLoaded = true;
    this.previewMode = true;
  }

  attemptAssessorLogin(){
      var loginFiltered = this.scheduleCandidates[0];
      if (loginFiltered !== null && loginFiltered !== undefined) {
        this.packageData(loginFiltered, "password");
        this.generalSvc.loginUser();
      } else {
        console.log("Could not login in to assessor exam.");
      }
    
    this.spinner.hide();
  }

  attemptAnonymousCandidateLogin(){
    var loginFiltered = this.scheduleCandidates[0];
    if (loginFiltered !== null && loginFiltered !== undefined) {
      this.packageData(loginFiltered, "password");
      this.generalSvc.loginUser();
    } else {
      console.log("Could not login in to candidate exam.");
    }
  
  this.spinner.hide();
}

  attemptLogin(username, password) {
    
    var isMock = this.mocks;
    if(isMock !== null && isMock !== undefined && this.mocks.MockId > 0){
      var loginFiltered = this.scheduleCandidates[0];
      if (loginFiltered !== null && loginFiltered !== undefined) {
        this.packageData(loginFiltered, password);
        this.generalSvc.loginUser();
      } else {
        console.log("Could not login in to mock exam.");
      }
    }
    else{
      var loginFiltered = this.scheduleCandidates.filter(x => x.username == username);
      if (loginFiltered.length > 0) {
        this.packageData(loginFiltered[0], password);
        this.generalSvc.loginUser();
      } else {
        console.log("You entered incorrect login details.");
      }
    }
    this.spinner.hide();
  }

  calculateProgress() {
    this.syncProgress = (((this.syncIndex + 1) / this.syncItems.length) * 100).toFixed(0) + "%";
  }

  shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
      }
  }

  packagePreview(){

  }

  packageData(scheduleCandidate, password) {
    var schedule = this.schedules.filter(x => x.ScheduleId == scheduleCandidate.ScheduleId)[0];
    var assessment = this.assessments.filter(x => x.AssessmentId == scheduleCandidate.AssessmentId);
    var media = [];
    var sessionsFiltered = this.sessionResults.filter(x => x.CandidateId == scheduleCandidate.CandidateId && x.ScheduleId == scheduleCandidate.ScheduleId && x.Status < 5);
    var mocks = this.mocks;
    var exams = [];
    sessionsFiltered.forEach(session => {      
      var sessionQuestions = this.sessionQuestions.filter(x => x.SessionId == session.SessionId).sort(this.dynamicSort("SectionOrder"));

      var questions = [];
      var tasks = this.tasks.filter(x => x.SessionId == session.SessionId);
      sessionQuestions.forEach(sessionQuestion => {
        var question = this.questions.filter(x => x.Question.QuestionID == sessionQuestion.QuestionId)[0];
        var questionResponses = this.questionResponses.filter(x => x.QuestionId == sessionQuestion.QuestionId);
        var questionMedia = this.questionMedia.filter(x => x.QuestionId == sessionQuestion.QuestionId);
                
        var questionResults = this.sessions.filter(x => x.SessionId == sessionQuestion.SessionId && x.QuestionId == sessionQuestion.QuestionId)[0];
        if (questionResults.MediaViewCount)
          questionResults._MediaViewCount = new Map(JSON.parse(questionResults.MediaViewCount));

        var _questionResponses = [];
        var responseIndex = 0;
        questionResponses.forEach(questionResponse => {
          if (question.Question.Type != 6 && question.Question.Type != 4 && question.Question.Type != 8)
          {
            try {
              if (questionResults.Selection.toString().indexOf(questionResponse.Id.toString()) > -1)
                questionResponse.Answer = true;
              else
                questionResponse.Answer = null;
            } catch {
              
            }
          }
          else if(question.Question.Type == 4 || question.Question.Type == 8){
            try{
              var answer = questionResults.Selection.toString();
              if(answer != "" && answer!= null && answer != undefined){
                questionResponse.Answer = answer
              }
            }
            catch{}            
          } else {
            try {
              var selectionArray = questionResults.Selection.toString().split(',')[responseIndex];
              questionResponse.Answer = selectionArray;
            } catch {

            }
            responseIndex++;
          }

          var questionResponseMedia = this.questionResponseMedia.filter(x => x.AnswerId == questionResponse.AnswerId);

          _questionResponses.push({
            "Response": questionResponse,
            "Media": questionResponseMedia,
            //"Feedback": false
          })
        });
    
        var questionResponsesAnswered = _questionResponses.filter(x => x.Response.Answer == true).length;
        var disabled = null; 

        if (question.Question.Type != 6 && question.Question.Type != 4 && question.Question.Type != 8)
        {
          if (question.NumberOfAnswers <= questionResponsesAnswered)
            disabled = true;
        }
        else if(question.Question.Type == 4 || question.Question.Type == 8){
          var answer = _questionResponses.filter(x => x.Response.Answer != null && x.Response.Answer != "").length;
          if(answer > 0){
            disabled = true;
          }
        }
         else {
          if (_questionResponses.filter(x => x.Response.Answer == null).length == 0)
            disabled = true;
        }

        var timeTaken = 0;

        try
        {
          timeTaken = questionResults.Timetaken;
        }
        catch
        {
          // 
        }

        questions.push({
          "TimeSpent": timeTaken,
          "SessionQuestion": sessionQuestion,
          "Question": question,
          // "Media": _media,
          "QuestionResponses": _questionResponses,
          "Result": questionResults,
          "Feedback": false,
          "Disabled": disabled,
          "SessionId": sessionQuestion.SessionId
        });
      });
      
      exams.push({
        "Session": session,
        "Questions": questions,
        "SessionQuestions": sessionQuestions,
        "Tasks" : tasks,
        "CurrentQuestion": 0,
        "Progress": 0,
        "Status": session.Status,
        "StatusText": "Not Started",
        
      });

      exams.forEach(exam => {
        exam.Questions.forEach(question => {
          question.Question.QuestionTextHiddenImages = this.processQuestionContent(question.Question.Question.Text, question.Question, false);
          question.Question.QuestionText = this.processQuestionContent(question.Question.Question.Text, question.Question, true);
        });
      });

      // console.log(exams);

      exams = JSON.parse(JSON.stringify(exams));
    });

    assessment.forEach(a => {
      if(Number(a.HeaderImage) > 0)
        media = this.media.filter(m => m.MediaId == a.HeaderImage);
    });

    this.currentUser = {
      "Assessment": assessment,
      "Media": media,
      "ScheduleCandidate": scheduleCandidate,
      "Schedule": schedule,
      "Mocks" : mocks,
      "Exams": exams,
      "PIN": password,
      "Language": {
        "Name" : "English"
      }
    };

    console.log("Current User", this.currentUser);
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
  }

  previousQuestion() {
    clearTimeout(this.changeQuestionTimer);
    this.changeQuestionTimer = setTimeout(() => { 
      this.pulseTimeLog('Previous');
      
      //saves result
      //this.submitResult(this.currentQuestion().Result);

      setTimeout(() => {
        this.updateViewerHeights();
      }, 2500);
      
      this.setQuestion(this.currentExam().CurrentQuestion - 1);
      
      this.checkQuestionsAnswered();
      this.setUpQuestionInfo();
    }, 100);
  }

  nextAdaptiveQuestion(){
    var answer = this.currentQuestion().Result.Selection;
    if(answer !== null && answer !== undefined && answer !== ""){
      var response = this.currentQuestion().QuestionResponses.filter(x => x.Response.AnswerId == answer)[0];
      if(response !== null && response !== undefined){
        if(response.Response.NextQuestionId !== null && response.Response.NextQuestionId !== undefined && response.Response.NextQuestionId !== 0){
          var nextQuestion = this.currentExam().Questions.filter(x => x.Question.Question.QuestionID == response.Response.NextQuestionId)[0];
          if(nextQuestion !== null && nextQuestion !== undefined){
            var index = this.currentExam().Questions.indexOf(nextQuestion);
            if(index !== null && index !== undefined){
              this.setQuestion(index);
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  nextQuestion() {   
    clearTimeout(this.changeQuestionTimer);
    this.changeQuestionTimer = setTimeout(() => { 
      this.pulseTimeLog('Next');

      var adaptiveNext = this.nextAdaptiveQuestion();
      if(!adaptiveNext){

        //saves result
        //this.submitResult(this.currentQuestion().Result);

        setTimeout(() => {
          this.updateViewerHeights();
        }, 2500);

        this.setQuestion(this.currentExam().CurrentQuestion + 1);

        //this.checkQuestionsAnswered();
        //this.setUpQuestionInfo();
      }
    }, 100);
  }

  setQuestion(i) {
    this.pulseTimeLog('Navbar');
    var question = document.getElementById("htmlCardHeader3");
    if(question !== undefined && question !== null){
      question.style.display = "block"
    }

    //saves current question
    if(!this.demoExam){
      this.saveMediaCount();
      this.submitResult(this.currentQuestion().Result);
    }    

    this.currentExam().CurrentQuestion = i;

    var nQuestion = this.currentQuestion();
    if (nQuestion != null && nQuestion != undefined) {
      if (!this.currentAssessment().CombineSections && nQuestion.SessionQuestion.SectionName != this.currentSectionName) {
        this.showSectionWelcome = true;
        this.currentSectionName = nQuestion.SessionQuestion.SectionName;
        this.sectionWelcomeCounter = 5;

        clearInterval(this.sectionInterval);
        this.sectionInterval = setInterval(() => { 
          this.sectionWelcomeCounter += -1; 
        }, 1000);

        clearTimeout(this.sectionTimeout);
        this.sectionTimeout = setTimeout(() => { 
          this.showSectionWelcome = false; 
          clearInterval(this.sectionInterval);
        }, 6000);
      }
    }

    this.checkQuestionsAnswered();
    this.setUpQuestionInfo();

    this.questionSettings.showQuestionText = true;

    this.loadCurrentQuestionAnswers();
    setTimeout(() => this.sendMediaUsageEvent(), 200);
    window.scrollTo(0,0);
}

  loadCurrentQuestionAnswers(){
    switch(this.currentQuestion().Question.QuestionType){
      case 1:
      case 2:
      case 3: {
        this.sendLoadMultiAnswersEvent();
        break;
      }
      case 4: {
        this.sendLoadFIBAnswersEvent();
        break;
      }
      case 5: {
        this.sendLoadEssayAnswersEvent();
        break;
      }
      case 7: {
        this.sendLoadDragDropAnswersEvent();
        break;
      }
      case 8: {
        this.sendLoadMatchingAnswersEvent();
        break;
      }
      case 11: {
        this.sendLoadMatrixLabelAnswersEvent();
        break;
      }
      case 14: {
        this.sendLoadMatrixSingleAnswersEvent();
        break;
      }
      case 15: {
        this.sendLoadMatrixNoteAnswersEvent();
        break;
      }
      case 22: {
        this.sendLoadOralAnswersEvent();
        break;
      }
      case 23: {
        this.sendLoadContextualAnswersEvent();
        break;
      }
      case 1023: {
        this.sendLoadEmailAnswersEvent();
        break;
      }
      case 1024: {
        this.sendLoadTabAnswersEvent();
        break;
      }
      case 1025: {
        this.sendLoadImageMapAnswersEvent();
        break;
      }
      case 1027: {
        this.sendLoadCarrouselOralAnswersEvent();
        break;
      }
      case 1028: {
        this.sendLoadMMFIBAnswersEvent();
        break;
      }
      case 1029: {
        this.sendLoadHighlightAnswersEvent();
        break;
      }
      case 1030: {
        this.sendLoadCarrouselAnswersEvent();
        break;
      }
      case 1032: {
        this.sendLoadUploadAnswersEvent();
        break;
      }
    }
  }

  isMediaLimitReached(answerId, mediaId) {
    if (answerId > 0) {
      let qrm = this.questionResponseMedia.find(_qrm => _qrm.AnswerId == answerId && _qrm.MediaId == mediaId);
      if (qrm !== undefined && qrm.ViewCount !== null && qrm.ViewCount > 0) {
        let mediaViewCount = this.currentQuestion().Result._MediaViewCount;
        if (mediaViewCount !== undefined && mediaViewCount !== null) {
          let viewCountId = `${answerId}-${mediaId}`;
          return mediaViewCount.has(viewCountId) && qrm.ViewCount <= mediaViewCount.get(viewCountId);
        }
      }
    }
    return false;
  }

  updateViewCount(id, answerId, mediaId, callback) {
    let limitReached = false;
    if (answerId > 0) { limitReached = this.updateAnswerViewCount(answerId, mediaId); }
    else { limitReached = this.updateQuestionViewCount(mediaId); }
  
    if (callback !== undefined && callback !== null) { callback(id, limitReached); }
  }
  
  updateAnswerViewCount(answerId, mediaId) {
    let qrm = this.questionResponseMedia.find(_qrm => _qrm.AnswerId == answerId && _qrm.MediaId == mediaId);
    if (qrm !== undefined && qrm.ViewCount !== null && qrm.ViewCount > 0) {
      if (this.currentQuestion().Result._MediaViewCount === undefined || this.currentQuestion().Result._MediaViewCount === null) {
        this.currentQuestion().Result._MediaViewCount = new Map();
      }
      let viewCountId = `${answerId}-${mediaId}`;
      let viewCount = 1;
      if (this.currentQuestion().Result._MediaViewCount.has(viewCountId)) {
        viewCount += this.currentQuestion().Result._MediaViewCount.get(viewCountId);
        if (qrm.ViewCount < viewCount) { return true; }
      }
      
      this.currentQuestion().Result._MediaViewCount.set(viewCountId, viewCount);
    }
    return false;
  }
  
  updateQuestionViewCount(mediaId) {
    return false;
  }

  saveMediaCount() {
    if (document.getElementById("hfMediaMapData")) {
      saveMediaUsage();
      this.currentQuestion().Result.MediaMapData = document.getElementById("hfMediaMapData").nodeValue || '';
    }
  }

  checkMockDetails(){

    var mock = this.currentUser.Mocks;
    if(mock !== null && mock !== undefined){
      if(mock.MockId > 0){
        return this.mocks;
      }
    }
    return null;
  }

  checkForBop(){
    var bop = this.currentUser.Exams[this.currentExamIndex].Bop;
    if(bop != null){
      return "(" + bop.Name + ")";
    }
    else{
      return " ";
    }
  }

  caseStudyExists(){
    if(this.currentQuestion().CaseStudies.length > 0){
      return true;
    }
    else{
      return false;
    }
  }

  flagResponse(reponseId){
    var questionResponse = this.currentQuestion().QuestionResponses.filter(x => x.Response.Id == reponseId);
    if(questionResponse[0].Feedback){
      questionResponse[0].Feedback = false;
    }
    else{
      questionResponse[0].Feedback = true;
    }
  }

  isResponseFlagged(reponseId){
    var questionResponse = this.currentQuestion().QuestionResponses.filter(x => x.Response.Id == reponseId);
    return questionResponse[0].Feedback;
  }

  getFeedbackResponses(){
    return this.currentExam().Questions;   
  }

  flagQuestion(){
    var flagged = this.currentQuestion().Feedback;
    if(flagged){
      this.currentQuestion().Feedback = false;

      // unflag responses;
      if (this.currentQuestion().Question.Type != 8 && this.currentQuestion().Question.Type != 4) {
        this.currentQuestion().QuestionResponses.forEach((response: any) => {
          response.Feedback = false;
        });
      }
    }
    else{
      this.currentQuestion().Feedback = true;

      // flag responses;
      if (this.currentQuestion().Question.Type != 8 && this.currentQuestion().Question.Type != 4) {
        this.currentQuestion().QuestionResponses.forEach((response: any) => {
          response.Feedback = true;
        });
      }
    }
    this.pulseTimeLog('Flagged');
  }

  isQuestionFlagged(){
    return this.currentQuestion().Feedback; 
  }

  getFeedbackQustions(){
    return this.currentExam().Questions.filter(x => x.Feedback == true);
  }

  getClickedMedia(){
    if(this.currentQuestion().Media !== undefined && this.currentQuestion().Media !== null)
      return this.currentQuestion().Media.filter(x => x.Activated == true);
      else
        return [];      
  }

  getClickedMediaId(mediaId){
    setTimeout(() => {
      this.updateViewerHeightsWithId(mediaId);
    }, 2500);
    return this.currentQuestion().Media.filter(x => x.Activated == true && x.Media.Id == mediaId);
  }

  addToClickedMedia(mediaId){
    var clickedMedia = this.getClickedMediaId(mediaId);
    if (clickedMedia.length == 0)
    {
      var media = this.media.filter(x => x.Id == mediaId)[0];
      var newMedia = {
        Media: media, 
        Activated: true
      };
      this.currentQuestion().Media.push(newMedia);
      this.getClickedMedia();
    }

    setTimeout(() => {
      this.updateViewerHeightsWithId(mediaId);
    }, 2500);
  }

  examTimer(){
    var currentQuestion = this.currentQuestion();
    var taskQuestion = this.taskQuestion(currentQuestion.Question.Question.QuestionID);
    if(taskQuestion !== null && taskQuestion !== undefined){
      var timer = taskQuestion.Timer;
      if(timer !== null && timer !== undefined && timer > 0){
        var questionTimeUsed = currentQuestion.SessionQuestion.TimeSpentMins;
        if(questionTimeUsed > timer){
          //logic for adapted procedure

          //logic for extra time
        }
      }
    }
  }

  getcurrentTask

  getTaskQuestionTimeUsed(){
    var tasks = this.currentExam().Tasks;
    var questions = this.currentExam().Questions;    
    for(var i = 0; i < tasks.length; i++){
      var timeUsed = 0;    
      var task = tasks[i];
      var qIds = task.QuestionIds.split(',');
      for(var x = 0; x < qIds.length; x++){
        var question = questions.filter(q => q.Question.Question.QuestionID == parseInt(qIds[x]))[0];
        if(question !== null && question !== undefined){
          timeUsed += question.SessionQuestion.TimeSpentMins;
        }
      }
      task.TimeUsed = (timeUsed / 60);
      var percenatge = (task.TimeUsed / task.Timer) * 100;
      //if(percenatge <= 100)
      task.Percentage = percenatge;
    }
  }

  checkTaskForExtraTimeUsed(questionId){
    var task = this.currentExam().Tasks.filter(x => x.QuestionIds.indexOf(questionId) > -1)[0];
    var questions = this.currentExam().Questions;
    var extraTimeUsed = 0;
    if(task !== null && task !== undefined){
      var qIds = task.QuestionIds.split(',');
      for(var x = 0; x < qIds.length; x++){
        var question = questions.filter(q => q.Question.Question.QuestionID == parseInt(qIds[x]))[0];
        if(question !== null && question !== undefined){
          extraTimeUsed += question.SessionQuestion.ExtraTimeSpentMins;
        }
      }
      task.ExtraTimeUsed = (extraTimeUsed);
      return task.ExtraTimeUsed;
    }
    return null;
  }

  taskQuestion(questionId){
    var tasks = this.currentExam().Tasks;
    if(tasks !== null && tasks !== undefined){
      for(var i = 0; i < tasks.length; i++){
        var task = tasks[i];
        var qIds = task.QuestionIds.split(',');
        for(var x = 0; x < qIds.length; x++){
          if(qIds[x] == questionId){
            return task;
          }
        }
      }
    }
    return null;
  }

  currentQuestion() {
    if(this.currentExam() !== null && this.currentExam() !== undefined){
      if(this.currentExam().Questions !== null && this.currentExam().Questions !== undefined)
        return this.currentExam().Questions[this.currentExam().CurrentQuestion];
    }
  }

  currentExam() {
    if(this.currentExamIndex >= 0){
    return this.currentUser.Exams[this.currentExamIndex];
    }
    return null;
  }

  currentAssessment() {
    if(this.currentExamIndex >= 0){
      return this.assessments.filter(x => x.AssessmentId == this.currentUser.Exams[this.currentExamIndex].Session.AssessmentId);
      }
      return null;
  }

  buildQuestionPreview(questionId){
    this.refetchConfigSettings();
    setTimeout(() => {
      this.spinner.show();
      this.downloadStatus = "Loading question preview ...";
      console.log(this.environment);
      var questionUrl = this.environment + "/authentication/PreviewQuestion/" + questionId;
      this.http.get(questionUrl).subscribe((data: any) => {
            if (data.status == "Success") {    
              this.prefixBlobUrl = this.blobUrl + "/"+ this.blobContainer +"/QuestionPreviews" + "/" + data.questionId;
              var suffixUrl = this.makeid(10);
              
              this.previewSyncItems[0].url = this.prefixBlobUrl + "/QuestionResponses.json?" + suffixUrl;
              this.previewSyncItems[1].url = this.prefixBlobUrl + "/Questions.json?" + suffixUrl;
              this.previewSyncItems[2].url = this.prefixBlobUrl + "/QuestionResponseMedia.json?" + suffixUrl; 
  
              this.processPreviewSync();
  
            } else if (data.status == "Error") {
              this.downloadStatus = data.message;
              setTimeout(() => {
                this.spinner.hide();
              }, 5000);
            }
          }, (error: any) => {
            this.downloadStatus = "Error getting question";
            setTimeout(() => {
              this.spinner.hide();
            }, 1000);
          });
    },1000);
    
  }

  // checkMultipleSelectionStatus(){
  //   var question = this.currentQuestion();
  //   if(question.Question.QuestionType === 3){
  //     var checkboxes = document.querySelectorAll("input[name='" + question.Question.Question.QuestionID + "']");
  //     if(question.Answered){
  //       for (var i = 0; i < checkboxes.length; i++) {
  //         var checkbox = (<HTMLInputElement>checkboxes[i])
  //         if(checkbox !== null && checkbox !== undefined){
  //           if(!checkbox.checked){
  //             checkbox.disabled = true;
  //           }
  //           else{
  //             checkbox.disabled = false;
  //           }
  //         }
  //       }
  //     }
  //     else{
  //       for (var i = 0; i < checkboxes.length; i++) {
  //         var checkbox = (<HTMLInputElement>checkboxes[i])
  //         if(checkbox !== null && checkbox !== undefined){            
  //             checkbox.disabled = false;
  //         }
  //       }
  //     }
  //   }   
  // }
  

  updateResponse(response, val) {
    if(this.previewMode){
      return;
    }

    var question = this.currentQuestion();
    if(question.Question.QuestionType === 1 || question.Question.QuestionType === 2){
      question.Result.Selection = response.Response.AnswerId;
      question.Answered = true;
      response.Checked = true;
    }
    else if(question.Question.QuestionType === 3){
      question.Answered = null;
        if(val == true){
          response.Checked = true;
          question.Result.Selection += response.Response.AnswerId + ",";
        }
        else{
          response.Checked = false;
          question.Result.Selection = question.Result.Selection.replace(response.Response.AnswerId + ",", "");
        }

      if (question.Result.Selection.split(",").length >= question.Question.Question.ResponsesCorrectCount) {
          question.Answered = true;          
      } 
      else {
          question.Answered = null;
      }

      // setTimeout(() => {
      //   this.checkMultipleSelectionStatus();
      // },500);
      
    }
      
    // var questionResponses = question.QuestionResponses.filter(x => x.Response.Answer == true);

    // if (questionResponses.length >= question.Question.ResponsesCorrectCount) {
    //   question.Answered = true;
    // } else {
    //   question.Answered = null;
    // }

    // var selectedIds = [];
    // questionResponses.forEach((response: any) => {
    //   selectedIds.push(response.Response.Id);
    // });

    // this.pulseTimeLog('Answer');

    // var answer = {
    //   "questionId": question.Question.QuestionId,
    //   "sessionId": this.currentExam().Session.SessionId,
    //   "answer": selectedIds.join(),
    //   "sectionId": question.SessionQuestion.SectionId,
    //   "questionDetailsId": question.SessionQuestion.QuestionDetailsId,
    //   "timeSpent": question.TimeSpent
    // };
    // this.submitResult(answer.sessionId, answer.questionId, answer.answer, answer.sectionId, answer.questionDetailsId, answer.timeSpent);

    //this.calculateExamProgress();
  }

  updateResponseMatching() {
    if(this.previewMode){
      return;
    }
    
    var question = this.currentQuestion();
    if (question.QuestionResponses.filter(x => x.Response.Answer == null).length == 0) {
      question.Disabled = true;
    } else {
      question.Disabled = null;
    }

    var questionResponses = question.QuestionResponses.filter(x => x.Response.Answer != null);

    var selectedIds = [];

    questionResponses.forEach((response: any) => {
      var questionMatch = question.Matches.filter(x => x.Id == response.Response.Answer)[0];
      //selectedIds.push(response.Response.Id + ":" + questionMatch.AnswerText)
      //selectedIds.push(response.Response.Answer);
      selectedIds.push(response.Response.Id + ":" + questionMatch.AnswerText);
    });

    this.pulseTimeLog('Answer');

    var answer = {
      "questionId": question.Question.QuestionId,
      "sessionId": this.currentExam().Session.SessionId,
      "answer": selectedIds.join(),
      "sectionId": question.SessionQuestion.SectionId,
      "questionDetailsId": question.SessionQuestion.QuestionDetailsId,
      "timeSpent": question.TimeSpent
    };

    //this.submitResult(answer.sessionId, answer.questionId, answer.answer, answer.sectionId, answer.questionDetailsId, answer.timeSpent);

    this.calculateExamProgress();
  }

  parseValueNumeric(question, val){  
    var regex = /[^0-9.-]*/g;
    if(val.charAt(0) == "."){
      val = val.replace(".", "0.")
    }
    if (val.indexOf(",") > -1){
      question.Comma = true;
      val = val.replace(",", "");
    } else {
      question.Comma = null;
    }
    return val.replace(regex, ''); 
  }

  updateResponseCalculationVal(answer)
  {
    var question = this.currentQuestion();
    answer = this.parseValueNumeric(question, answer);

    // Update response answer;
    question.QuestionResponses[0].Response.Answer = answer;

    if(answer != null && answer != undefined){
      question.Disabled = true;
    }
    else{
      question.Disabled = false;
    }

    this.pulseTimeLog('Answer');

    var _answer = {
      "questionId": question.Question.QuestionId,
      "sessionId": this.currentExam().Session.SessionId,
      "answer": answer,
      "sectionId": question.SessionQuestion.SectionId,
      "questionDetailsId": question.SessionQuestion.QuestionDetailsId,
      "timeSpent": question.TimeSpent
    };
    //this.submitResult(_answer.sessionId, _answer.questionId, _answer.answer, _answer.sectionId, _answer.questionDetailsId, _answer.timeSpent);

    this.calculateExamProgress();
  }

  updateResponseCalculation(obj, answer){
    var question = this.currentQuestion();
    answer = this.parseValueNumeric(question, answer);
    obj.value = answer;

    // Update response answer;
    question.QuestionResponses[0].Response.Answer = answer;

    if(answer != null && answer != undefined){
      question.Disabled = true;
    }
    else{
      question.Disabled = false;
    }

    this.pulseTimeLog('Answer');

    var _answer = {
      "questionId": question.Question.QuestionId,
      "sessionId": this.currentExam().Session.SessionId,
      "answer": answer,
      "sectionId": question.SessionQuestion.SectionId,
      "questionDetailsId": question.SessionQuestion.QuestionDetailsId,
      "timeSpent": question.TimeSpent
    };

    //this.submitResult(_answer.sessionId, _answer.questionId, _answer.answer, _answer.sectionId, _answer.questionDetailsId, _answer.timeSpent);
    this.calculateExamProgress();
  }

  calculateExamProgress() {
    var questions = this.currentExam().Questions;
    var completed = questions.filter(x => x.Disabled == true);
    this.currentExam().Progress = this.round((completed.length / questions.length) * 100);
  }

  EndExam()
  {
    if(!this.demoExam){
      this.spinner.show();
      this.downloadStatus = this.translateText() + "...";
      var sessionId = this.currentExam().Session.SessionId;
      this.pulseTimeLog('End');
  
      //saves result
      this.submitResult(this.currentQuestion().Result);
  
      this.submitCompletion(sessionId);
    }
    else{
      var enetsecure = this.enetsecureMobile ? "enetsecuremobile=1" : this.enetsecureWeb ? "enetsecureweb=1" : "";
      this.generalSvc.logoutUser(enetsecure);
    }
  }

  translateText(){
    var language = this.currentUser.Language.Name;
    if(language == "Arabic"){      
        return "اكتمل التقييم-تقديم النتائج";
    }
    else if(language == "Azerbaijani"){      
      return "Qiymətləndirmə sona çatdı – Nəticələrin təqdim edilməsi";
    }
    else if(language == "Chinese"){      
        return "测评完成，正在提交结果";
    }
    else if(language == "Croatian"){      
        return "Procjena je završena – slanje rezultata";   
    }
    else if(language == "Czech"){      
        return "Hodnocení dokončeno – odesílají se výsledky";
    }
    else if(language == "Dutch"){     
        return "Toets beëindigd - Resultaten verzenden";
    }
    else if(language == "English"){     
        return "Assessment Finished – Submitting Results";
    }
    else if(language == "French"){    
        return "Évaluation terminée – soumission des résultats";
    }
    else if(language == "German"){      
        return "Prüfung abgeschlossen – Ergebnisse einreichen";
    }
    else if(language == "Hindi"){      
        return "Question(s) Flagged for Review";
    }
    else if(language == "Hungarian"){
        return "Értékelő teszt kész – Eredmények beküldése";
    }
    else if(language == "Indonesian"){
        return "Question(s) Flagged for Review";
    }
    else if(language == "Italian"){    
        return "Valutazione terminata – Invio risultati in corso";
    }
    else if(language == "Malay"){    
        return "Question(s) Flagged for Review";
    }
    else if(language == "Norwegian"){     
        return "Evaluering avsluttet – overfører resultater";
    }
    else if(language == "Polish"){
              return "Test zakończony – przesyłanie wyników";
    }
    else if(language == "Portuguese"){      
        return "Question(s) Flagged for Review";
    }
    else if(language == "Portuguese Brazilian"){      
        return "Avaliação concluída – enviando resultados";
    }
    else if(language == "Romanian"){
        return "Evaluare încheiată – Se transmit rezultatele";
    }
    else if(language == "Russian"){      
        return "Тест завершен — выполняется отправка результатов";
    }
    else if(language == "Spanish"){     
        return "Evaluación finalizada – Enviando resultados";
    }
    else if(language == "Spanish South American"){      
        return "Evaluación finalizada – Enviando resultados";
    }
    else if(language == "Thai"){     
        return "การประเมินเสร็จสิ้น - กำลังส่งผลลัพธ์";
    }
    else if(language == "Turkish"){      
        return "Değerlendirme Bitti – Sonuçlar Gönderiliyor";
    }
    else{
      return "Assessment Finished – Submitting Results";
    }
  }

  processQuestionContentReview(question)
  {
    var content = question.Question.Text;
    var mid = 0;
    var regex = /<img.*?src="(.*?)"/;
      try
      {
        var src = regex.exec(content)[1];
        var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");

        mid = Number(mediaId);
      } catch (e) {
        
        try {
          regex = /<img.*?src='(.*?)'/;
          var src = regex.exec(content)[1];
          var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");
          mid = Number(mediaId);
        } catch (es) {

        }
      }
      return mid;
  }

  processQuestionContent(content, question, show) {
    if(content !== null && content !== undefined){
      if (show){
        var regex = /<img.*?src="(.*?)"/;
        try
        {
          var src = regex.exec(content)[1];
          var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");
          var media = question.Media.filter(x => x.Media.Id == mediaId)[0];
          question.Question.QuestionTextMedia = media.Media.Id;
          content = content.replace("src=\"" + src, "class=\"image_in_question\" onclick=\"document.getElementById('img_"+ mediaId +"').click(); this.style.display = 'none';\" src=\"data:image/png;base64," + media.Media.Data);
        } catch (e) {
          try {
            regex = /<img.*?src='(.*?)'/;
            var src = regex.exec(content)[1];
            var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");
            var media = question.Media.filter(x => x.Media.Id == mediaId)[0];
            question.Question.QuestionTextMedia = media.Media.Id;
            content = content.replace("src='" + src, "class=\"image_in_question\" onclick=\"document.getElementById('img_"+ mediaId +"').click(); this.style.display = 'none';\" src='data:image/png;base64," + media.Media.Data);
          } catch (e) {
  
          }
        }
      }else{
        var content = content.replace(/<img[^>]*>/g,"");
      }
      return content;
    }    
  }

  round(value) {
    var multiplier = Math.pow(10, 0);
    return Math.round(value * multiplier) / multiplier;
  }

  roundToDecimal(value) {
    var multiplier = Math.pow(10, 1);
    return Math.round(value * multiplier) / multiplier;
  }

  runQuery(query) {

  }

  getQuery(query) {

  }

  getAll(query) {
    return "";
  }

  updateViewerHeights()
  {
    var imageViewers: any = document.querySelectorAll(".image-gallery-2");
    imageViewers.forEach(imageViewer => {
      this.setViewerHeight(imageViewer);
    });

    setTimeout(() => {
      var buttons: any = document.querySelectorAll(".material-icons.prev");
      buttons.forEach(button => {
        button.click();
      });
    }, 500);
  }

  updateViewerHeightsWithId(mediaId)
  {
    var imageViewers: any = document.querySelectorAll("#media_container_" + mediaId + ".image-gallery-2");
    imageViewers.forEach(imageViewer => {
      this.setViewerHeight(imageViewer);
    });

    setTimeout(() => {
      var buttons: any = document.querySelectorAll("#media_container_" + mediaId + " .material-icons.prev");
      buttons.forEach(button => {
        button.click();
      });
    }, 500);
  }

  setViewerHeight(imageViewer: any)
  {
    var i = imageViewer.querySelectorAll("img")[0];
    var scaleH = i.height / i.width;
    var currentW = imageViewer.clientWidth;
    imageViewer.style.height = (currentW * scaleH).toString() + "px";
  }

  // Submit data to the API;
  public resultInterval = null;
  public logInterval = null;

  //CURRENTLY COMMENTED OUT - WILL NEED TO BE READDED ONCE THE METHOD HAS BEEN CREATED ON THE API SIDE
  startSyncMethods()
  {
    this.logInterval = setInterval(() => {
      this.determineLocalIp();
      this.determinePublicIp();
      this.pulseTimeLog("Pulse");
    }, 30000);
  }

  stopSyncMethods()
  {
    clearInterval(this.logInterval);
  }

  getResults()
  {
    this.spinner2.hide();
  }

  pulseTimeLog(action) {
    this.lastAction = action;

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var connectionInfo = "";

    try {
      if (connection.type != null && connection.type != undefined)
        connectionInfo += " - T: " + connection.type;
    } catch (e) {

    }
    try{
      var networkState = navigator.connection.type;

      var states = {};
      states[Connection.UNKNOWN] = 'Unknown connection';
      states[Connection.ETHERNET] = 'Ethernet connection';
      states[Connection.WIFI] = 'WiFi connection';
      states[Connection.CELL_2G] = 'Cell 2G connection';
      states[Connection.CELL_3G] = 'Cell 3G connection';
      states[Connection.CELL_4G] = 'Cell 4G connection';
      states[Connection.NONE] = 'No network connection';
      
      connectionInfo += " - CT: " + states[networkState];
    }catch(e){

    }
    try {
      if (connection.downlink != null && connection.downlink != undefined)
        connectionInfo += " - D: " + connection.downlink;
    } catch (e) {

    }

    try {
      if (connection.rtt != null && connection.rtt != undefined)
        connectionInfo += " - R: " + connection.rtt;
    } catch (e) {

    }

    try {
      if (connection.downlinkMax != null && connection.downlinkMax != undefined)
        connectionInfo += " - DM: " + connection.downlinkMax;
    } catch (e) {

    }

    try {
      if (connection.effectiveType != null && connection.effectiveType != undefined)
        connectionInfo += " - ET: " + connection.effectiveType;
    } catch (e) {

    }

    try {
      if (connection.saveData != null && connection.saveData != undefined)
        connectionInfo += " - SD: " + connection.saveData;
    } catch (e) {

    }

    var version = document.getElementById("version").innerHTML;
    var sessionId = this.currentExam().Session.SessionId;
    var assessmentId = this.currentExam().Session.AssessmentId;
    var scheduleId = this.currentExam().Session.ScheduleId;
    var candidateId = this.currentUser.ScheduleCandidate.CandidateId;
    var scheduleCandidateId = this.currentExam().Session.ScheduleCandidateId;
    var ipAddress = this.lastAction + "_" + (this.ipAddress.length == 0 ? this.publicIpAddress : this.ipAddress);
    var cdnServerLocation = (sessionId + "_" + scheduleCandidateId + "_" + version + " - " + this.deviceInfo + connectionInfo);
    if(this.enetsecureMobile){
      cdnServerLocation = cdnServerLocation + "_eNetSecureMobile";
    }
    else if(this.enetsecureWeb){
      cdnServerLocation = cdnServerLocation + "_eNetSecureWeb";
    }
    var allocatedTime = 0;// parseInt(session.AllotedTime) + parseInt(session.ExtraTime);
    var secondsSpent = 0;
    var extraTime = this.currentQuestion().SessionQuestion.ExtraTimeSpentMins;
    var adaptedTime = this.currentQuestion().SessionQuestion.AdapatedTimeSpentMins;
    if(this.currentExam().Session.UseQuestionTime){
      secondsSpent = this.currentQuestion().SessionQuestion.TimeSpentMins;      
    }
    else{
      secondsSpent = this.currentQuestion().Question.TimeSpent;
    }
    

    cdnServerLocation = decodeURI(cdnServerLocation);
    cdnServerLocation = cdnServerLocation.replace(/ +(?= )/g,'');
    cdnServerLocation = cdnServerLocation.replace(/\\/g, '');
    cdnServerLocation = cdnServerLocation.replace(/(\r\n|\n|\r)/gm, "");
    cdnServerLocation = cdnServerLocation.replace(/:/g," ");
    console.log(cdnServerLocation);

    this.submitTimeLog(sessionId, assessmentId, this.currentQuestion().SessionQuestion.QuestionId, scheduleId, candidateId, ipAddress, cdnServerLocation, allocatedTime, secondsSpent, extraTime, adaptedTime);

    this.lastAction = "";
  }
  recordDisconnection()
  {
    var sessionId = this.currentExam().Session.SessionId;
    this.submitDisconnect(sessionId, this.disconnectTime);
  }

  submitResult(result){
    this.downloadStatus = "Submitting answer...";
    var saveAnswers = true;
    var isMock = this.checkMockDetails();
    if(isMock !== null){
      saveAnswers = isMock.RecordResult;
    }

    if(this.demoExam){
      saveAnswers = false;
    }

    if(saveAnswers){
      var url = this.environment + "/result/save/"+ result.ResultId;
      if (result._MediaViewCount instanceof Map) {
        result.MediaViewCount = JSON.stringify(Array.from(result._MediaViewCount.entries()));
      }
      var data = JSON.stringify(result);
  
      this.http.post(url, data).subscribe((res: any) => {
        if(res.status == "Error")
          console.error(res.message);
      },
      (error: any) => {
        console.log(error);
        this.noConnectionError();
      });
    }
    
  }

  showLoading(str) { 
    this.downloadStatus = str;
    this.spinner.show();
  }

  hideLoading(str) { 
    this.downloadStatus = str;
    this.spinner.hide();
  }

  /*submitResult(sessionId, questionId, answer, sectionId, questionDetailsId, timeSpent)
  {
    this.spinner2.show();
    this.downloadStatus = "Submitting answer...";

    if (this.currentUser.ScheduleCandidate.LoginId == "CR-000000") 
      this.getResults();
    
    if (answer == "")
      answer = "-NOANSWER-";

    var url = this.environment + "/result/" + sessionId + "/" + questionId + "/" + answer + "/" + sectionId + "/" + questionDetailsId + "/" + timeSpent;
    
    this.http.get(url).subscribe((data: any) => {
      this.getResults();
    },
    (error: any) => {
      //
      this.noConnectionError();
    });
  }*/

  // isQuestionAnswered(){
  //   var currentQuestion = this.currentQuestion();
  //   if(currentQuestion.Result.Selection !== null && currentQuestion.Result.Selection !== undefined && currentQuestion.Result.Selection !== ""){
  //     currentQuestion.Answered = true;
  //   }
  //   else{
  //     currentQuestion.Answered = false;
  //   }
  // }

  setUpQuestionInfo(){
    var question = this.currentQuestion().Question;
    var questionId = question.Question.QuestionID;
    this.supplementary = "";
    this.context = "";
    this.questionName = question.Question.Name;

    this.questionText = this.sanitizer.bypassSecurityTrustHtml(this.currentQuestion().Question.QuestionText);

    clearTimeout(this.questionLayoutTimer);
    clearInterval(this.questionLayoutInterval);
    this.questionLayoutTimer = setTimeout(() => this.determineQuestionLayout(),800);
    
    // this.questionLayoutInterval = setInterval(() => {
    //   var currentQuestion = this.currentQuestion().Question.Question;
    //   if(currentQuestion.QuestionDisplayType === 2 && currentQuestion.Type !== 1025)
    //   {
    //     var answerArea: any = document.getElementById("answerArea");
    //     var cardHeader: any = document.getElementById("htmlCardHeader3");
    //     var top = window.pageYOffset + cardHeader.getBoundingClientRect().top;
    //     answerArea.style.marginTop = top.toString() + "px";
    //   } else {
    //     answerArea.style.marginTop = "0px";
    //   }
    // }, 100);
    
    try {
      var questionTextKey = "questionText_" + this.currentExam().Session.SessionId;
      var qt: any = localStorage.getItem(questionTextKey);
      var j = [];

      var cleansedQuestionText = this.currentQuestion().Question.QuestionText.trim();

      if (qt == undefined || qt == null) {
        localStorage.setItem(questionTextKey, JSON.stringify(j));
      } else {
        j = JSON.parse(qt);
      }

      console.log()
      var filtered: any = j.filter((x: any) => x.key == cleansedQuestionText);
      console.log(filtered);
      
      var any = filtered.length > 0;

      if (any) {
        this.questionText = this.sanitizer.bypassSecurityTrustHtml(filtered[0].value);
      }

      clearInterval(this.intervalUpdateQuestionText);
      this.intervalUpdateQuestionText = setInterval(() => {
        this.updateQuestionTextHtml();
        var html = document.getElementsByClassName("questionTextBody")[0];
        var htmlStr = "";
        if(html !== null && html !== undefined){
          htmlStr = html.innerHTML;
        }
        var cleansedQuestionText2 = this.currentQuestion().Question.QuestionText.trim();
        var questionTextKey2 = "questionText_" + this.currentExam().Session.SessionId;
        var j2: any = localStorage.getItem(questionTextKey2);
        var qt2: any = JSON.parse(j2.toString());

        var filtered2: any = qt2.filter((x: any) => x.key == cleansedQuestionText2);
        var any2 = filtered2.length > 0;
        
        if (!any2) {
          qt2.push({
            "key": cleansedQuestionText2,
            "value": htmlStr
          });
        }

        qt2.forEach((qt2Item: any) => {
          if (qt2Item.key == cleansedQuestionText2) {
            qt2Item.value = htmlStr;
          }
        });

        localStorage.setItem(questionTextKey2, JSON.stringify(qt2));
      }, 1000);

    } catch(e) {
      
    }

    if(this.questionText == undefined){
      this.questionText = this.sanitizer.bypassSecurityTrustHtml(this.currentQuestion().Question.Text);
    }
    var task =  this.taskQuestion(questionId.toString());
    if(task !== null && task !== undefined){
      var taskContext = task.Components.filter(x => x.Type == "Context")[0];
      var taskSupplementary = task.Components.filter(x => x.Type == "Instruction")[0];

      if(taskContext !== null && taskContext !== undefined && taskContext !== ""){
        this.context = this.sanitizer.bypassSecurityTrustHtml(taskContext.Content);
      }
      else if(question.Question.QuestionContext !== null && question.Question.QuestionContext !== undefined && question.Question.QuestionContext !== ""){
        this.context = this.sanitizer.bypassSecurityTrustHtml(question.Question.QuestionContext);
      }

      if(taskSupplementary !== null && taskSupplementary !== undefined && taskSupplementary !== ""){
        this.supplementary = this.sanitizer.bypassSecurityTrustHtml(taskSupplementary.Content);
      }
      else if(question.Question.SupplementaryText !== null && question.Question.SupplementaryText !== undefined && question.Question.SupplementaryText !== ""){              
        this.supplementary = this.sanitizer.bypassSecurityTrustHtml(question.Question.SupplementaryText);
      }
    }
    else{
      if(question.Question.SupplementaryText !== null && question.Question.SupplementaryText !== undefined && question.Question.SupplementaryText !== ""){
        this.supplementary = this.sanitizer.bypassSecurityTrustHtml(question.Question.SupplementaryText);
      }

      if(question.Question.QuestionContext !== null && question.Question.QuestionContext !== undefined && question.Question.QuestionContext !== ""){
        this.context = this.sanitizer.bypassSecurityTrustHtml(question.Question.QuestionContext);
      }
    }
  }

  updateQuestionTextHtml() {
    var inputs = document.querySelectorAll<HTMLInputElement>('.questionTextBody input');

    inputs.forEach(obj => {
      if (obj.type == 'checkbox') {
        if (obj.checked == true) {
          obj.setAttribute('checked', 'checked');
        } else {
          obj.removeAttribute('checked');
        }
      }
    
      if (obj.type == 'text') {
        obj.setAttribute('value', obj.value);
      }
    });
  }

  determineQuestionLayout(){
    var currentQuestion = this.currentQuestion().Question.Question;
    var questionArea = document.getElementById("questionArea");
    var answerArea = document.getElementById("answerArea");

    if(currentQuestion.QuestionDisplayType === 2 && currentQuestion.Type !== 1025){
      //2 = horizontal displays
      //1025 = image maps and these need to be fullscreen regardles sor coordinates are affected.      
      if(currentQuestion.QuestionHorizontalDisplayType !== null && currentQuestion.QuestionHorizontalDisplayType !== undefined && currentQuestion.Type !== 1025){
          if(currentQuestion.QuestionHorizontalDisplayType === 4){
            //InputLeft
            if(answerArea !== null && answerArea !== undefined){
              answerArea.setAttribute("class", "");
              answerArea.setAttribute("class", "col col-md-8");
              answerArea.setAttribute("style", "float:left;height: 100%;order: 1;");
            }

            if(questionArea !== null && answerArea !== undefined){
              questionArea.setAttribute("class", "");
              questionArea.setAttribute("class", "col col-md-4");
              questionArea.setAttribute("style", "float:right;height: 100%;order: 2;");     
            }       
          }
          else if(currentQuestion.QuestionHorizontalDisplayType === 3){
            //InputRight
            if(answerArea !== null && answerArea !== undefined){
              answerArea.setAttribute("class", "");
              answerArea.setAttribute("class", "col col-md-8");
              answerArea.setAttribute("style", "float:right;height: 100%;order: 2;");
            }

            if(questionArea !== null && answerArea !== undefined){
              questionArea.setAttribute("class", "");
              questionArea.setAttribute("class", "col col-md-4");
              questionArea.setAttribute("style", "float:left;height: 100%;order: 1;");  
            }
          }
          else if(currentQuestion.QuestionHorizontalDisplayType === 2){
            //OutputLeft
            if(answerArea !== null && answerArea !== undefined){
              answerArea.setAttribute("class", "");
              answerArea.setAttribute("class", "col col-md-4");
              answerArea.setAttribute("style", "float:right;height: 100%;order: 2;");
            }

            if(questionArea !== null && answerArea !== undefined){
              questionArea.setAttribute("class", "");
              questionArea.setAttribute("class", "col col-md-8");
              questionArea.setAttribute("style", "float:left;height: 100%;order: 1;"); 
            } 
          }
          else if(currentQuestion.QuestionHorizontalDisplayType === 1){
            //OutputRight
            if(answerArea !== null && answerArea !== undefined){
              answerArea.setAttribute("class", "");
              answerArea.setAttribute("class", "col col-md-4");
              answerArea.setAttribute("style", "float:left;height: 100%;order: 1;");
            }

            if(questionArea !== null && answerArea !== undefined){
              questionArea.setAttribute("class", "");
              questionArea.setAttribute("class", "col col-md-8");
              questionArea.setAttribute("style", "float:right;height: 100%;order: 2;");  
            }
          }
      }
      setTimeout(() => {
        this.updateTheQuestionPosition();
      },2000)
      
    }
    else{
      if(answerArea !== null && answerArea !== undefined){
        answerArea.setAttribute("class", "col-md-12");
        answerArea.setAttribute("style", "order: 2;");
      }
      if(questionArea !== null && questionArea !== undefined){
        questionArea.setAttribute("class", "col-md-12");
        questionArea.setAttribute("style", "order: 1;");  
      }
    }
  }

  updateTheQuestionPosition(){
    if(this.aibcMode){
      checkQuestionPosition();
    }
  }

  IsAnswered(question){
    //TEXT BASED ANSWERS
    if(question.Question.QuestionType == "1"
    || question.Question.QuestionType == "2"
    || question.Question.QuestionType == "3"    
    || question.Question.QuestionType == "5"
    || question.Question.QuestionType == "11"
    || question.Question.QuestionType == "14"
    || question.Question.QuestionType == "15"
    || question.Question.QuestionType == "22"
    || question.Question.QuestionType == "23"
    || question.Question.QuestionType == "1024"
    || question.Question.QuestionType == "1025"      
    || question.Question.QuestionType == "1027"  
    || question.Question.QuestionType == "1029"
    || question.Question.QuestionType == "1030"
    || question.Question.QuestionType == "1032"
    ){
      if(question.Result.Selection !== null && question.Result.Selection !== undefined && question.Result.Selection !== ""){
        question.Answered = true;
      }
      else{
        question.Answered = false;
      }
    }
    else if (question.Question.QuestionType == "1023") {
      var index = question.Result.Selection.lastIndexOf('|||');
      if (index > -1) {
        question.Answered = question.Result.Selection.substring(index+3).length > 0;
      }
    }
    else if(question.Question.QuestionType == "4"){
      question.Answered = true;
      var answer = question.Result.Selection.split(",");
      for(var a = 0; a < answer.length; a++){
        if(answer[a] === ""){
          question.Answered = false;
          break;
        }
      }
    }
    else if(question.Question.QuestionType == "8"){
      var keywords = question.Question.Question.Keywords.split(";").length;
      var answer = question.Result.Selection.split("|").length;
      if(keywords == answer){
        question.Answered = true;
      }
    }
    else if(question.Question.QuestionType == "1028"){
      //MMFIB
      if(question.Result.Selection !== null && question.Result.Selection !== undefined && question.Result.Selection !== ""){        
        var result = question.Result.Selection.split(",");
        var matchNotAns = 0;
        for(var r = 0; r < result.length; r++){
          if(result[r] == "" || result[r] == " "){
            matchNotAns++;
          }
        } 
        if(matchNotAns > 0){
          question.Answered = false;
        }
        else{
          question.Answered = true;
        }    
      }
      else{
        question.Answered = false;
      }
    }
    // else if(question.Question.QuestionType == "3"){
    //   // MULTI SELECT - COUNTS AS ANSWERED WHEN NUMBER OF ANSWERS MATCHES AMOUNT GIVEN
    //   var answersExpected = question.Question.Question.ResponsesCorrectCount;
    //   if(answersExpected !== null && answersExpected !== undefined && answersExpected > 0){
    //     var givenAnswers = question.Result.Selection.split(",");
    //     if(givenAnswers !== null && givenAnswers !== undefined && givenAnswers !== ""){
    //       var answerCount = givenAnswers.length - 1;

    //       if(answerCount == answersExpected){
    //         question.Answered = true;
    //       }
    //       else{
    //         question.Answered = false;
    //       }
    //     }
    //   }
    // }
    else if(question.Question.QuestionType == "7"){
      //DRAG DROP
      var answer = question.Result.Selection;
      var originalAnswer = question.Question.OriginalAnswer;
      if(originalAnswer == null || originalAnswer == undefined || originalAnswer == ""){
        question.Question.OriginalAnswer = question.Result.Selection;
      }
      //if(answer.indexOf("\"answers\":[]") === -1 && answer !== null && answer !== undefined && answer !== ""){
      if(answer != originalAnswer){
        question.Answered = true;
      }
      else{
        question.Answered = false;
      }
    }
    return question.Answered;
  }

  showUnanswered(){
    var unanswered = this.checkQuestionsAnswered();
    return unanswered;
  }

  checkQuestionsAnswered(){
    var unansweredCounter = 0;
    this.currentExam().Questions.forEach(x => {
      var answered = this.IsAnswered(x);
      if(!answered){
        unansweredCounter++;
      }
    })
    if(unansweredCounter > 0){
      return true;
    }
    else{
      return false;
    }

  }

  countAnswersWords(){
    var answer = this.currentQuestion().Result.Selection.toString();
    if(answer !== ""){
      var currentAnswer = answer.trim().replace(/<[^>]*>/g, ' ').replace(/\\[nrt]{1}/g, ' ').replace(/\s\s+/g, ' ');
      var count = currentAnswer.split(/\s+/g).trim().filter((x) => x !== '' && x !== '&nbsp;' && x !== ' ').length;
      return count;
      
    }
    else{
      return 0;
    }    
  }

  countEmailAnswersWords(){
    var answer = this.currentQuestion().Result.Selection.toString();
    if(answer !== ""){
      if(answer.indexOf("###To:") > -1){
        var first = answer.indexOf("###To:");
        var last = answer.lastIndexOf("###") + 3;

        var replaceTxt= answer.substring(first, last);
        answer = answer.replace(replaceTxt, "");
      }
      if(answer.indexOf("$$$Subject:") > -1){
        var first = answer.indexOf("$$$Subject:");
        var last = answer.lastIndexOf("$$$") + 3;
        var replaceTxt = answer.substring(first, last);
        answer = answer.replace(replaceTxt, "");
      }
      if(answer.indexOf("|||Attachment:") > -1){
        var first = answer.indexOf("|||Attachment:");
        var last = answer.lastIndexOf("|||") + 3;
        var replaceTxt = answer.substring(first, last);
        answer = answer.replace(replaceTxt, "");
      }

      var currentAnswer = answer.trim().replace(/<[^>]*>/g, ' ').replace(/\\[nrt]{1}/g, ' ');
      var count = currentAnswer.split(/\s+/g).filter((x) => x !== '' && x !== '&nbsp;' && x !== ' ').length;
      return count;
    }
    else{
      return 0;
    }    
  }

  noConnectionError()
  {
    this.connectionFailCount = 1;
    this.spinner.show();

    this.connectionFailInterval = setInterval(() => {
      this.downloadStatus = "Connection to eNetAssess lost... Logging out in " + this.connectionFailCount.toString();
      this.connectionFailCount++;

      if (this.connectionFailCount > 5)
      {
        this.spinner.hide();
        window.location.reload();
      }
    }, 1000);
  }

  submitTimeLog(sessionId, assessmentId, questionId, scheduleId, userId, ipAddress, cdnServerLocation, allocatedTime, secondsSpent, extraTime, adaptedTime)
  {
    var url = this.environment + "/result/pulse/" + sessionId + "/" + assessmentId + "/" + questionId + "/" + scheduleId + "/" + userId + "/" + ipAddress + "/" + cdnServerLocation + "/" + allocatedTime + "/" + secondsSpent + "/" + extraTime + "/" + adaptedTime;
    this.http.get(url).subscribe((data: any) => {
      // 
    },
    (error: any) => {
      //
      //this.noConnectionError();
    });
  }
  submitDisconnect(sessionId, milliseconds)
  {
    this.determineLocalIp();
    this.determinePublicIp();
    
    if(!this.demoExam){
      var url = this.environment + "result/disconnect/" + sessionId + "/" + milliseconds;

      // Add disconnect time to exam;
      this.http.get(url).subscribe((data: any) => {
      },
      (error: any) => {
        //
        this.noConnectionError();
      });
    }
  }

  public interval: any;

  submitCompletion(sessionId)
  {
    this.downloadStatus = "Exam Complete - submitting answers...";
    // Stop exam timer;
    clearInterval(this.interval);
    // Stop other timers from running;
    this.stopSyncMethods();
    this.pulseTimeLog('Complete');
    var saveAll = true;
    
    var isMock = this.checkMockDetails();
    if(isMock !== null){
      if(!isMock.RecordResult){
        saveAll = false;
        // Submit completion;
        var url = this.environment + "/result/completemock/" + sessionId;
        this.http.get(url).subscribe((data: any) => {      
          // Completed;
          this.currentExam().Completed = true;
          this.spinner.hide();
          this.generalSvc.goToEnetassess();
        },
        (error: any) => {
          //
          this.noConnectionError();
        });
      }
    }
    if(this.demoExam){
      saveAll = false;
      var enetsecure = this.enetsecureMobile ? "enetsecuremobile=1" : this.enetsecureWeb ? "enetsecureweb=1" : "";
      this.generalSvc.logoutUser(enetsecure);
    }

    if(saveAll){
      // Submit completion;
      var url = this.environment + "/result/complete/" + sessionId;
      this.http.get(url).subscribe((data: any) => {      
        // Completed;
        this.currentExam().Completed = true;
        this.spinner.hide();
        if(isMock || this.currentUser.Exams[this.currentExamIndex].Session.AssessmentEnableFeedback || this.currentUser.Exams[this.currentExamIndex].Session.AssessmentDisplayResult){
          this.generalSvc.goToFeedback()
        }
        else if(this.assessorExam){
          this.generalSvc.logoutAssessor();
        }
        else if(this.anonymousCandidateExam){
          this.generalSvc.logoutAnonymousCandidate();
        }
        else{
        this.generalSvc.goToEnetassess();
        }
      },
      (error: any) => {
        //
        this.noConnectionError();
      });
    }
  }

  scrollToTop() {
    document.querySelectorAll("*").forEach((obj: HTMLElement) => {
      obj.scroll({top:0,behavior:'smooth'});
    });
  }

  updateSessionStatus(sessionId, status){
   if(!this.demoExam){
      var url = this.environment + "/result/updateSessionStatus/" + sessionId + "/" + status;
      this.http.get(url).subscribe((data: any) => {},
      (error: any) => {
        console.log(error);
        //this.noConnectionError();
      });
    }
  }

  updateScheduleCandidateStatus(sessionId, status){
    if(!this.demoExam){
       var url = this.environment + "/result/updateScheduleCandidateStatus/" + sessionId + "/" + status;
       this.http.get(url).subscribe((data: any) => {},
       (error: any) => {
         console.log(error);
         //this.noConnectionError();
       });
     }
   }

  submitFeedback(sessionId, feedback)
  {
    //var feedbackString = feedback.toString().split('(').join('_').split(')').join('~').split('?').join('¬').split('/').join('|');
    //var url = this.environment + "/feedback/" + sessionId + "/" + encodeURIComponent(feedbackString);
    this.postFeedback(sessionId, feedback);
  }

  postFeedback(sessionId, feedback) {
    
    var feedbackString = feedback.toString().split('(').join('_').split(')').join('~').split('?').join('¬').split('/').join('|');
    feedbackString = feedbackString.replace("\"", "&quot;");

    var json = {
      "Feedback" : feedbackString
    }
    var url = this.environment + "/result/PostFeedback/" + sessionId + "/" + json;
    this.http.post(url, json).subscribe((data:any) => {
      this.generalSvc.goToEnetassess();
    }, (error:any) => {
      this.noConnectionError();
    });
  }

  submitFeedbackShorten(url) {
    var tinyurl = 'http://tinyurl.com/api-create.php?url=' + url;
    return this.http.get(tinyurl).subscribe((data: any) => {
      if(data != null){
        this.http.get(data.toString()).subscribe((d: any) => {
          this.generalSvc.goToEnetassess();
        },(error: any) => {

        });
      }
    },(error: any) => {
      alert(error);
    });
  }

  submitAttachment(questionId, extension, data){
    if(!this.demoExam){
      var url = this.environment 
      + "/Media/UploadAttachment/" + this.currentExam().Session.SessionId
      + "/" + questionId + "/" + extension;

      if(data.indexOf("base64,"))
        data = data.substr(data.indexOf("base64,") + 7, 9999999);

      this.http.post(url, {data: data}).subscribe((res: any) => {
      if(res.status == "Error")
      console.error(res.message);
      },
      (error: any) => {
        console.log(error);
      //this.noConnectionError();
      });
    }
  }

  tikTokChecker(tab) { 
    if (tab.indexOf('https://www.tiktok.com') > -1) {
      try {
        var wrapper= document.createElement('div');
        wrapper.innerHTML = tab;
        var blockquotes = wrapper.getElementsByTagName("blockquote");
        for (var i = 0; i < blockquotes.length; i++) {
          var blockquote = blockquotes[i];
          var cite = blockquote.getAttribute("cite");
          var parts = cite.split("/");
          var id = parts[parts.length - 1];
          tab = "<iframe src='https://www.tiktok.com/embed/"+ id +"' width='100%' height='500px' scrolling='yes' frameborder='0'></iframe>";
        }
      } catch (e) {
        
      }
    }
    return tab;
  }

  //#region Load Answers
  
  sendLoadMultiAnswersEvent(){
    this.subject.next();
  }

  sendLoadFIBAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadEssayAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadDragDropAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadMatchingAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadMatrixLabelAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadMatrixSingleAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadMatrixNoteAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadOralAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadContextualAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadEmailAnswersEvent(){
    this.subject.next();
  }

  sendLoadUploadAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadTabAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadImageMapAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadCarrouselOralAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadMMFIBAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadHighlightAnswersEvent(){
    this.subject.next();
  }
  
  sendLoadCarrouselAnswersEvent(){
    this.subject.next();
  }

  sendMediaUsageEvent() {
    this.mediaUsageSubject.next();
  }
  
  getLoadMultiAnswersEvent(){
    return this.subject.asObservable();
  }

  getLoadFIBAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadEssayAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadDragDropAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadMatchingAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadMatrixLabelAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadMatrixSingleAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadMatrixNoteAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadOralAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadContextualAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadEmailAnswersEvent(){
    return this.subject.asObservable();
  }

  getLoadUploadAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadTabAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadImageMapAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadCarrouselOralAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadMMFIBAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadHighlightAnswersEvent(){
    return this.subject.asObservable();
  }
  
  getLoadCarrouselAnswersEvent(){
    return this.subject.asObservable();
  }

  getMediaUsageEvent() {
    return this.mediaUsageSubject.asObservable();
  }

  //#endregion

}